import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function NotFound() {
  return (
    <main
      data-testid="not-found-page"
      className="min-h-screen bg-[#0A0A0A] text-[#F5F5F5] flex items-center justify-center px-6"
    >
      <div className="max-w-xl text-center">
        <div className="inline-flex items-center gap-2 pill-tag mb-8">
          <span className="pill-dot"></span>
          Chyba 404
        </div>
        <h1 className="text-[96px] sm:text-[140px] font-extrabold leading-none tracking-tight">
          <span className="text-[#C6F432]">404</span>
        </h1>
        <h2 className="mt-4 text-2xl sm:text-3xl font-bold tracking-tight">
          Stránka, ktorú hľadáš, neexistuje.
        </h2>
        <p className="mt-4 text-white/55">
          Možno bola presunutá alebo bola zadaná zlá adresa. Vráť sa na úvod
          a pokračuj v prehliadaní portfólia.
        </p>
        <Link
          data-testid="not-found-home-link"
          to="/"
          className="mt-8 inline-flex items-center gap-2 px-6 py-3.5 rounded-full bg-[#C6F432] text-[#0A0A0A] font-semibold text-sm hover:bg-white transition-colors btn-shine"
        >
          <ArrowLeft className="w-4 h-4" />
          Späť na úvod
        </Link>
      </div>
    </main>
  );
}
